import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { InvoiceDetail } from 'packages/invoices/ui/invoiceDetail/InvoiceDetail';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Fragments
const RouteBase = () => {
  return <InvoiceDetail />;
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <RouteBase />
      </Flex>
    </RouteErrorBoundary>
  );
};
